module.exports = __webpack_public_path__ + "static/media/bz.e6b5e204.svg";